import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { Entry, EntrySkeletonType } from "contentful";
import dynamic from "next/dynamic";
import { Key } from "react";

const EditorialAccordion = dynamic(
  () => import("./editorial-accordion/editorial-accordion"),
);
const EditorialAsset = dynamic(
  () => import("./editorial-asset/editorial-asset"),
);
const EditorialBanner = dynamic(
  () => import("./editorial-banner/editorial-banner"),
);
const EditorialDescription = dynamic(
  () => import("./editorial-description/editorial-description"),
);
const EditorialLoyalty = dynamic(() => import("./loyalty/editorial-loyalty"));
const Hero = dynamic(() => import("./hero/hero"));
const HeroSlide = dynamic(() => import("./hero/hero-slide"));
const HeroVideo = dynamic(() => import("./hero/hero-video"));
const JsonPreview = dynamic(() => import("./json-preview"));

export type EditorialEntryProps = {
  entry: Entry<EntrySkeletonType>;
  key?: Key;
};

export default function EditorialEntry(props: EditorialEntryProps) {
  const liveEntry = useContentfulLiveUpdates(props.entry);

  switch (liveEntry.sys.contentType.sys.id) {
    case "hero":
      return <Hero entry={liveEntry} />;
    case "heroSlide":
      return <HeroSlide entry={liveEntry} />;
    case "heroVideo":
      return <HeroVideo entry={liveEntry} />;
    case "editorialAccordions":
      return <EditorialAccordion entry={liveEntry} />;
    case "editorialBanner":
      return <EditorialBanner entry={liveEntry} />;

    case "editorialDescription":
      return <EditorialDescription entry={liveEntry} />;
    case "breakpointAwareAsset":
      return <EditorialAsset entry={liveEntry} />;
    case "loyalty":
      return <EditorialLoyalty entry={liveEntry} />;
    default: {
      if (process.env.NODE_ENV === "development") {
        return <JsonPreview data={props} />;
      }

      return null;
    }
  }
}
